//Start JS-Script part, taken form sample page
function ActivateEmailId(GUID) {
    var URL = "/TCWServices/TCWService.svc/ActivateMailId?GUID=" + GUID;
    $.ajax({
        type: "GET",
        contentType: "application/json; charset=UTF-8;",
        url: URL,
        dataType: "json",
        async: false,
        success: function (data) {
            if (data == true) {

                $("#ContentPlaceHolder1_confirmationDiv").hide();
                $("#ContentPlaceHolder1_formDiv").hide();
                $("#ContentPlaceHolder1_ActivationDiv").show();
            }
            //alert("success data " + $('#hdnAddressFromString').val());                 
        },
        error: function (error) {
            debugger;
            //alert("Error" + error);
        }
    });

};
function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    //return "c03fc5f1-f0df-4f49-a04d-e056dd12e0ff";
};
function ValidateFormPageItems( segmentKeywordId, Token, virtualPath) {
	
    if ( (($('#hdnPageType').val() == 'SampleOrder') || ($('#hdnPageType').val() == 'Coupon'))) {
        $('.btn.btn-no-icon.field-submit').attr('disabled','disabled');
        $('.btn.btn-no-icon.field-submit').addClass('btn-inactive');
    }
    var invalidCount = 0;
    $('.field').blur();
    if(  $('.invalid').is(':visible'))
    {
        invalidCount = 1;
    }   

    if ($('.validate-message').is(':visible'))
    {
        invalidCount = 1;
    }       
    /*Code added by remaining target group project*/
    if(typeof SampleSizeValidation ==="function")
    {
        invalidCount += SampleSizeValidation();
    }
    /*End of code added by remaining target group project*/ 
    if (invalidCount == 0)
    {
        var frmSerilized = $("div#form :input").serialize();
        if (frmSerilized !== '') {
            getFormPageItems(frmSerilized, segmentKeywordId, Token, virtualPath);
        }
        if (($('#hdnAddressFromString').val() == 'true') && (($('#hdnPageType').val() == 'SampleOrder') || ($('#hdnPageType').val() == 'Coupon'))) {
            return true;
        }
        else {
            return false;
        }
    }
    else {               
        //event.keyCode = 0;
        if ( (($('#hdnPageType').val() == 'SampleOrder') || ($('#hdnPageType').val() == 'Coupon'))) {
            $('.btn.btn-no-icon.field-submit').removeAttr('disabled');
            $('.btn.btn-no-icon.field-submit').removeClass('btn-inactive');
        }
		
        var $elementWithError=$('div.validate-message[style*="display: block"]');
  
        if($elementWithError.length>0)
        {
            var $firstElement=$elementWithError.first();
            var elementTop = $elementWithError.offset().top;
            var elementBottom = elementTop + $elementWithError.outerHeight();
            var stickyMenuHeight= $('div.menu-wrapper.sticky').height()===null?0:$('div.menu-wrapper.sticky').height();
            var mobileHeaderHeight=$('div#mobilemainheader:visible').height()===null?0:$('div#mobilemainheader:visible').height();
            var viewportTop = $(window).scrollTop()+stickyMenuHeight+mobileHeaderHeight;
            var viewportBottom = viewportTop + $(window).height();
            if(!(elementBottom > viewportTop && elementTop < viewportBottom))
            {
                $firstElement.parent('.form-field').find('.field:first').focus();
                $('html,body').animate({
                    scrollTop: $firstElement.offset().top-stickyMenuHeight-mobileHeaderHeight-120
                }, 500);
            }   
        }
        return false;
    }
};

document.getElementById('form1').onkeypress = function (e) {
    if (!e) e = window.event;
    var keyCode = e.keyCode || e.which;
    if (keyCode == '13' && e.target.tagName != 'TEXTAREA') {
        if (!ValidatePageItems()) {
            e.preventDefault();
        }
        else {
        }
    }
};

function getFormPageItems( frmSerilized, segmentKeywordId, Token, virtualPath) {
    //Code added as part of remaining target group
    //var segmentKeywordId="<%= Helper.GetAppsettingKeyValue<string>("TENAMenSegmentKeyword")%>";
    //Code added as part of remaining target group
    var componentTCMId = $('#divtcm').attr('data-tcmid');
    var pageTCMId = $('#ContentPlaceHolder1_hdnPageId').val();
    var parentComponentTCMId = "";
    if($('input#mainComponentId').length>0){
        parentComponentTCMId =$('input#mainComponentId').val();
    }
    var ReqFrom = $("#hdnPageType").val();
    var IsNotSampleOrCoupon= (ReqFrom != "SampleOrder") && (ReqFrom != "Coupon") ;  
    //var Token="<%= Helper.GenerateToken() %>";
    var URL=  virtualPath + "TCWServices/TCWService.svc/SaveFormData";
    var PostData= { HtmlData: frmSerilized, TcmId: componentTCMId , ReqFrom: ReqFrom ,PageTcmId:pageTCMId ,DomainName: window.location.origin,SegmentId:segmentKeywordId ,ParentComponentId:parentComponentTCMId,Token:Token};
    
	$.ajax({
        type: "POST",
        contentType: "application/json; charset=UTF-8;",
        url: URL,
        async: IsNotSampleOrCoupon,
        data: JSON.stringify(PostData),
        beforeSend: function(){ if(IsNotSampleOrCoupon){$('#preloader').addClass('show'); } },
        complete: function(){ if(IsNotSampleOrCoupon){$('#preloader').removeClass('show');} },
        success: function (data) {
            if (data.success == true) 
            {
				
                if ((ReqFrom != "SampleOrder") && (ReqFrom != "Coupon")) {
                    window.scrollTo(0, 0);
                    if(data.status==200)
                    {
                        $("#ContentPlaceHolder1_confirmationDiv").show();
                        $("#ContentPlaceHolder1_formDiv").hide();
                        $("#ContentPlaceHolder1_ActivationDiv").hide();
                        //Code for google analytics
                        if(ReqFrom.toLowerCase() == "newsletter" )
                        {
                            if(dataLayer)
                            {
                                dataLayer.push({
                                    'event': 'newsletter-signup'
                                });
                            }
                        }

                        else if(ReqFrom.toLowerCase() == "askthedoctor")
                        {
                            dataLayer.push({
                                'event': 'engagement',
                                'action': 'askTheDoctor'
                            });
                        } 

                                                         
                    }
                    else if (data.status==300)
                    {
                        if(ReqFrom.toLowerCase()=="newsletter" || ReqFrom.toLowerCase()=="unsubscribe")
                        {
                            $("#ContentPlaceHolder1_AlertDiv").show();
                            $("#ContentPlaceHolder1_ActivationDiv").hide();
                        }
                    }
                }
                else {
                    $("#divMessage").val("Data has been saved successfully");
                }
            }
            $('#hdnAddressFromString').val(data.success);
        },
        error: function (error) {
            debugger;
             
        }
    });
}
(function ($) {
    	
        $("#products").change(function () {
            var selectedValue = $(this).val();
 			$('#ContentPlaceHolder1_hdnSelectedSampleItemId').val(selectedValue);
        });
})(jQuery);